import { colors } from '@workday/canvas-kit-react-core';
import chroma from 'chroma-js';
export var expandHex = function (hex) {
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    return hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });
};
var colorPriority = [
    colors.frenchVanilla100,
    colors.blackPepper300,
    colors.blackPepper400,
    colors.blackPepper500,
    colors.blackPepper600,
];
export var pickForegroundColor = function (background, darkColor, lightColor) {
    if (chroma.valid(background)) {
        if (lightColor && chroma.contrast(background, lightColor) >= 4.5) {
            return lightColor;
        }
        else if (darkColor && chroma.contrast(background, darkColor) >= 4.5) {
            return darkColor;
        }
        else {
            for (var i = 0; i < colorPriority.length; i++) {
                var color = colorPriority[i];
                if (chroma.contrast(background, color) >= 4.5) {
                    return color;
                }
            }
        }
    }
    return;
};
